import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { apiFetch, getTheme, noSelect, viewportWidth } from 'helpers'
import { Route } from 'react-router-dom'
import svgRight from 'assets/svg/icon-right.svg'

import EditInfo from 'containers/EditInfo'
import ChangePassword from 'containers/ChangePassword'
import svgLoading from 'assets/svg/icon-loading-coral.svg'

const menus = [
  { key: 'info', title: 'ข้อมูลทั่วไป' },
  { key: 'change-password', title: 'เปลี่ยนรหัสผ่าน' }
]

export default class extends Component {
  componentDidMount () {
    this._redirect(this.props)
  }

  componentWillReceiveProps (nextProps) {
    this._redirect(nextProps)
  }

  _redirect = (props) => {
    if (viewportWidth() > 767 && props.location.pathname === '/settings') {
      props.history.replace('/settings/info')
    }
  }

  render () {
    const { match } = this.props
    return (
      <Section>
        <ColLeft>
          <Route exact={viewportWidth() < 768} path={match.path} component={Root} />
        </ColLeft>
        <ColRight>
          <Route exact path={`${match.path}/info`} component={EditInfo} />
          <Route exact path={`${match.path}/change-password`} component={ChangePassword} />
        </ColRight>
      </Section>
    )
  }
}

const Section = styled.section`
  @media(min-width: 1080px) {
    width: 100%;
    margin: 0 auto;
    max-width: 1080px;
    padding: 30px 0px;
  }
  @media(min-width: 768px) and (max-width: 1079px) {
    width: calc(100% - 20px);
    margin: 0px 10px;
    padding: 30px 0px;
  }
`
const ColLeft = styled.div`
  @media(min-width: 768px) {
    display: inline-block;
    vertical-align: top;
    width: 248px;
    margin-right: 20px;
    border-radius: 10px;
    border: 1px solid ${getTheme`colorBorder`};
    overflow: hidden;
  }
`
const ColRight = styled.div`
  @media(min-width: 768px) {
    display: inline-block;
    vertical-align: top;
    width: calc(100% - 272px);
    border-radius: 10px;
    border: 1px solid ${getTheme`colorBorder`};
    background-color: white;
    overflow: hidden;
  }
`

@connect()
class Root extends Component {
  state = { loggingOut: false }
  _onLogout = () => {
    const { dispatch, history } = this.props
    if (this.state.loggingOut) return
    this.setState({ loggingOut: true }, () =>
      apiFetch({
        method: 'POST',
        v4: true,
        url: '/v4/vendors/logout'
      })
        .then(() => {
          dispatch({ type: 'SEND_MESSAGE', messageType: 'success', message: 'ออกจากระบบสำเร็จ' })
          this.setState({ loggingOut: false })
          history.replace('/login')
        })
        .catch(() => {
          dispatch({ type: 'SEND_MESSAGE', messageType: 'error', message: 'ออกจากระบบไม่สำเร็จ, กรุณาลองใหม่อีกครั้ง' })
          this.setState({ loggingOut: false })
        })
    )
  }

  render () {
    const { history, match, location } = this.props
    return (
      <Container>
        {menus.map(({ key, title }) =>
          <Button key={key} active={location.pathname === `${match.url}/${key}`} onClick={() => history.replace(`${match.url}/${key}`)}>
            <span>{title}</span>
            <IconRight src={svgRight} />
          </Button>
        )}
        <Button red onClick={this._onLogout}>
          <span>ออกจากระบบ</span>
          {this.state.loggingOut && <IconLoading alt='' src={svgLoading} />}
        </Button>
      </Container>
    )
  }
}

const Container = styled.section`

`
const Button = styled.div`
  font-size: 16px;
  height: 48px;
  line-height: 48px;
  text-indent: 20px;
  position: relative;
  border-bottom: 1px solid ${getTheme`colorBorder`};
  @media(min-width: 768px) {
    &:last-child { border-bottom: 0px; }
    > img { display: none; }
    cursor: pointer;
    background-color: white;
    &:hover { background-color: ${getTheme`colorBackground`}; }
    transition: background-color 0.3s ease;
  }

  cursor: pointer;
  position: relative;
  ${noSelect}
  transition: opacity 0.3s ease;
  &:hover {
    opacity: 0.8;
  }

  ${props => props.active ? `
    color: ${props.theme.colorTiffanyDark};
  ` : `
    color: black;
    background-color: white;
  `}
  ${props => props.red ? `color: ${props.theme.colorCoral};` : ''}
`
const IconRight = styled.img`
  width: 12px;
  height: 21px;
  vertical-align: top;
  position: absolute;
  right: 10px;
  top: 14px;
`
const IconLoading = styled.img`
  position: absolute;
  top: 14px;
  right: 10px;
  width: 20px;
  height: 20px;
  vertical-align: top;
`



// WEBPACK FOOTER //
// ./src/containers/Settings.js